export var TABLE_HIERARCHY_INDENTS = {
  1: '2rem',
  2: '3rem',
  3: '4rem',
  4: '5rem',
  5: '6rem',
  6: '7rem'
};
export var nextTableHierarchyDepth = function (depth) {
  return Math.min(depth + 1, 5);
};